import DashboardSection from "./DashboardSection";

import "./WorkflowPipeline.css";

const STEP_LABELS = {
  aanmelding: "Aanmelding",
  administratie: "Administratie",
  begeleiding: "Begeleiding",
  vdab: "VDAB",
  kld: "KLD",
  afronding: "Afronding",
};

export default function WorkflowPipeline({ items = [] }) {
  const total = items.reduce((sum, item) => sum + Number(item.count || 0), 0);

  return (
    <DashboardSection
      title="Workflow pipeline"
      description="Aantal dossiers per huidige stap."
    >
      <div className="workflow-pipeline">
        {items.length === 0 ? (
          <div className="workflow-pipeline__empty">Geen workflowgegevens.</div>
        ) : (
          items.map((item) => {
            const percentage = total > 0 ? (item.count / total) * 100 : 0;

            return (
              <div key={item.step} className="workflow-pipeline__item">
                <div className="workflow-pipeline__top">
                  <strong>{STEP_LABELS[item.step] || item.step}</strong>
                  <span>{item.count}</span>
                </div>

                <div className="workflow-pipeline__bar">
                  <div style={{ width: `${percentage}%` }} />
                </div>
              </div>
            );
          })
        )}
      </div>
    </DashboardSection>
  );
}
